<template>
  <UPageHeader :title="title">
    <template #links>
      <UButton
        v-if="backTo || showBackButton"
        :to="backTo"
        color="neutral"
        icon="i-heroicons-arrow-left"
        :label="undefined"
        class="sm:hidden"
        variant="ghost"
        @click="onBack"
      />
      <UButton
        v-if="backTo || showBackButton"
        :to="backTo"
        color="neutral"
        icon="i-heroicons-arrow-left"
        label="Zurück"
        class="hidden sm:flex"
        variant="ghost"
        @click="onBack"
      />
      <UButton
        v-if="showSync"
        :loading="syncing"
        color="neutral"
        icon="i-heroicons-arrow-path"
        :label="undefined"
        class="sm:hidden"
        variant="outline"
        @click="$emit('sync')"
      />
      <UButton
        v-if="showSync"
        :loading="syncing"
        color="neutral"
        icon="i-heroicons-arrow-path"
        :label="syncLabel"
        class="hidden sm:flex"
        variant="outline"
        @click="$emit('sync')"
      />
      <slot name="extra-actions" />
      <UButton
        :loading="saving"
        color="primary"
        icon="i-heroicons-check"
        :label="undefined"
        class="sm:hidden"
        @click="$emit('save')"
      />
      <UButton
        :loading="saving"
        color="primary"
        icon="i-heroicons-check"
        label="Speichern"
        class="hidden sm:flex"
        @click="$emit('save')"
      />
    </template>

    <template #description>
      <div class="flex flex-col gap-2 mt-2">
        <p v-if="tenantName" class="text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-widest">
          {{ tenantName }}
        </p>
        <div v-if="lastUpdate || lastEditor || lastSync" class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-400">
          <div v-if="lastUpdate" class="flex items-center gap-1.5">
            <UIcon name="i-heroicons-clock" class="w-3.5 h-3.5" />
            <span>Letzte Änderung: {{ new Date(lastUpdate).toLocaleString() }}</span>
          </div>
          <div v-if="lastSync" class="flex items-center gap-1.5">
            <UIcon name="i-heroicons-arrow-path" class="w-3.5 h-3.5" />
            <span>Letzter RAG Sync: {{ new Date(lastSync).toLocaleString() }}</span>
          </div>
          <div v-if="lastEditor" class="flex items-center gap-1.5">
            <UIcon name="i-heroicons-user" class="w-3.5 h-3.5" />
            <span>Bearbeiter: {{ lastEditor }}</span>
          </div>
        </div>
      </div>
    </template>
  </UPageHeader>
</template>

<script lang="ts" setup>
defineProps({
  title: String,
  tenantName: String,
  lastUpdate: String,
  lastSync: String,
  lastEditor: String,
  backTo: String,
  showBackButton: Boolean,
  saving: Boolean,
  showSync: Boolean,
  syncing: Boolean,
  syncLabel: {
    type: String,
    default: 'Sync',
  },
})

const emit = defineEmits(['save', 'sync', 'back'])

const onBack = () => {
  emit('back')
}
</script>
